<template>
    <div class="message-flags">
        <div v-if="message.flags.priority_high">
            <i class="fas fa-exclamation-circle"></i>
            <span>{{Language.say('messages.open.priority')}}</span>
        </div>
      <div v-if="message.flags.flagged">
            <i class="fas fa-bookmark"></i>
            <span>{{Language.say('messages.open.flagged')}}</span>
        </div>
    </div>
</template>

<script setup>
  import {defineProps} from 'vue';
  import Language      from '@/js/Shared/Language/Language.js';

  const props = defineProps({
   message : {
     required : true,
   },
  })
</script>
